import { Inject } from '@odinjs/odin';

import { ConfigurationDataProps, Endpoint } from '@philips-emr/hpms-stipulator-commons';
import { FormAPI, TextAreaAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { SubmittableFragmentContext } from '@philips-emr/tws-core/lib/component/context';
import { MountEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import BaseController from '../BaseController';

@Controller({ fragment: 'inclusao-beneficiario-cancelar' })
export default class InclusaoBeneficiarioCancelarController extends BaseController {

  @Inject('SubmittableFragmentContext')
  submittableFragmentContext: SubmittableFragmentContext;
  @Inject('form-cancelar-solicitacao')
  formCancelarSolicitacao: FormAPI;

  @OnMount({ target: ['text-area-observacao'] })
  onMount(event: MountEvent): void {
    const api = event.target as TextAreaAPI;
    const nrSeqContrato = this.context.get('nrSeqContrato');
    const nrSeqInclusao = this.context.get('nrSeqInclusao');

    void HttpService.get<{ dsObservacao: string }>(Endpoint.GET.INC_BENEF_OBSERVACAO, { nrSeqContrato, nrSeqInclusao })
      .then(response => api.setValue(response.body as unknown as string));
  }

  @OnClick({ target: ['button-confirmar'] })
  onClick(): void {
    const nrSeqContrato = this.context.get('nrSeqContrato');
    const nrSeqInclusao = this.context.get('nrSeqInclusao');
    const form = this.formCancelarSolicitacao;

    if (form.isValid()) {

      const record = form.getRecord();
      record.nrSeqMotivoReprov && (record.nrSeqMotivoReprov = (record.nrSeqMotivoReprov as ConfigurationDataProps).nrSeqMotivoReprov);

      void HttpService.post(Endpoint.POST.INC_BENEF_CANCELAR, { nrSeqContrato, nrSeqInclusao, ...record })
        .then(() => this.submittableFragmentContext.submit({} as SubmitEvent));
    }
  }
}
